export const firebaseConfig = {
  apiKey: 'AIzaSyCSxxKSioxrGt5oB2YbYGLUSmkCafTcTQQ',
  authDomain: 'stage-housing-react-fire.firebaseapp.com',
  databaseURL: 'https://stage-housing-react-fire.firebaseio.com',
  storageBucket: 'https://stage-housing-react-fire.firebaseio.com',
  messagingSenderId: '751816629784'
};



// WEBPACK FOOTER //
// ./src/core/firebase/config.js